import { render, staticRenderFns } from "./SimMovimientosForm.vue?vue&type=template&id=f63a7fc0&scoped=true&"
import script from "./SimMovimientosForm.vue?vue&type=script&lang=ts&"
export * from "./SimMovimientosForm.vue?vue&type=script&lang=ts&"
import style0 from "./SimMovimientosForm.vue?vue&type=style&index=0&id=f63a7fc0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f63a7fc0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('f63a7fc0', component.options)
    } else {
      api.reload('f63a7fc0', component.options)
    }
    module.hot.accept("./SimMovimientosForm.vue?vue&type=template&id=f63a7fc0&scoped=true&", function () {
      api.rerender('f63a7fc0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/InventarioSim/SimMovimientosForm.vue"
export default component.exports